import type { ColumnSort } from '@tanstack/react-table';

export const DEFAULT_SORT_BY = {
  id: 'name',
  desc: true,
};

const SORT_PARAM = 'sort_by';

export function parseSortByFromUrlParams(
  urlParams: URLSearchParams,
  defaultSortBy = DEFAULT_SORT_BY,
): ColumnSort {
  const sort = urlParams.get(SORT_PARAM);

  return {
    id: sort?.replace('+', '').replace('-', '') ?? defaultSortBy.id,
    desc: sort?.startsWith('-') ?? defaultSortBy.desc,
  };
}

export function formatSortByToUrlParams(
  sortBy?: ColumnSort,
  urlParams?: URLSearchParams,
  defaultSortBy = DEFAULT_SORT_BY,
): URLSearchParams {
  const newUrlParams = new URLSearchParams(urlParams);

  if (sortBy && sortBy.id) {
    const isDefault =
      sortBy.id === defaultSortBy.id && sortBy.desc === defaultSortBy.desc;

    if (isDefault) {
      newUrlParams.delete(SORT_PARAM);
    } else {
      const sortValue = `${sortBy.desc ? '-' : '+'}${sortBy.id}`;

      newUrlParams.set(SORT_PARAM, sortValue);
    }
  }

  return newUrlParams;
}
